import { ISPEnvironment } from './environment.interface';

export const environment = {
  production: true,
  sentry: 'dragon-front@v5.376.0',
} as ISPEnvironment;
